import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "download-block" }
const _hoisted_3 = { class: "download-block" }
const _hoisted_4 = { class: "block-title payload" }
const _hoisted_5 = { class: "download-block" }
const _hoisted_6 = {
  key: 0,
  class: "file-upload-result-label empty"
}
const _hoisted_7 = {
  key: 1,
  class: "file-upload-result-label error"
}
const _hoisted_8 = {
  key: 2,
  class: "file-upload-result-label success"
}
const _hoisted_9 = {
  key: 1,
  class: "divider"
}
const _hoisted_10 = {
  key: 2,
  class: "user-info-block"
}
const _hoisted_11 = {
  key: 0,
  class: "user-data-loading-label"
}
const _hoisted_12 = { class: "push-block" }
const _hoisted_13 = { class: "payment-block" }
const _hoisted_14 = { class: "block-title payment" }
const _hoisted_15 = {
  key: 0,
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"position":"relative","top":"2px","margin-left":"4px"}
}
const _hoisted_16 = {
  key: 1,
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"position":"relative","top":"2px","margin-left":"4px"}
}
const _hoisted_17 = { class: "catalog" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "content-wrapper" }
const _hoisted_20 = { class: "item-title" }
const _hoisted_21 = { class: "item-buy-action-content" }
const _hoisted_22 = { class: "item-price" }
const _hoisted_23 = { class: "payment-block" }
const _hoisted_24 = {
  href: "https://t.me/domyland",
  class: "block"
}

import AppButton from "@/components/AppButton.vue";
import { onMounted, ref } from "vue";
import { Domyland } from "@domyland-shared/mini-app-sdk";

// refs

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const fileInputElement = ref<HTMLInputElement | null>(null);

// data
const isFileUploadError = ref(false);
const fileUploadResponse = ref(false);
const userInfoCells = ref<Record<"title" | "content", string>[]>([]);
const isUserDataLoading = ref(false);
const catalogItems = [
  { title: "Цветы в горшке", price: "1100", img: "flowers-catalog.png" },
  { title: "Ноутбук", price: "700", img: "laptop.png" },
];

// methods
async function postFile(e?: InputEvent): Promise<void> {
  try {
    const files = (e?.target as HTMLInputElement).files;

    if (!files?.length) return;

    const file = files[0];
    const formData = new FormData();

    formData.set("file[]", file);

    const data = await fetch("https://uploads.domyland.com", {
      method: "POST",
      body: formData,
    });

    fileUploadResponse.value = (await data.json()).items[0].success;

    if (!fileUploadResponse.value) throw Error;

    isFileUploadError.value = false;
  } catch (e) {
    isFileUploadError.value = true;
  }
}

async function makePush(): Promise<void> {
  try {
    await Domyland.miniApp.sendDemoPush();
  } catch (e) {
    alert(e);
  }
}

async function buyItem(
  item: Record<"title" | "price" | "img", string | number>
): Promise<void> {
  await Domyland.miniApp.pay([
    { title: item.title as string, sum: Number(item.price), quantity: 1 },
  ]);
}

async function goToChat(): Promise<void> {
  try {
    await Domyland.superApp.chat();
  } catch (e) {
    alert(e);
  }
}

function goToPaywalls() {
  try {
    Domyland.superApp.redirect("paywall");
  } catch (e) {
    alert(e);
  }
}

const downloadFile = () => {
  const linkElement = document.createElement("a");

  linkElement.setAttribute("href", "laptop.png");
  linkElement.setAttribute("target", "_blank");
  linkElement.setAttribute("download", "test_image_file");

  linkElement.click();
};

const phoneFormat = (s: string, plus = true) => {
  const startsWith = plus ? "+7" : "8";

  let phone = s.replace(/[^0-9]/g, "");
  if (phone.startsWith("7") && plus) {
    phone = phone.substr(1);
  }
  if (phone.startsWith("8")) {
    phone = phone.substr(1);
  }

  return phone.replace(
    /(\d{3})(\d{3})(\d{2})(\d{2})/g,
    `${startsWith} ($1) $2 $3 $4`
  );
};

// hooks
onMounted(async () => {
  isUserDataLoading.value = true;

  const userData = (await Domyland.miniApp.userInfo([]))?.data;

  isUserDataLoading.value = false;

  if (userData?.roleId) {
    let roleTitle = "";

    switch (userData.roleId) {
      case 1:
        roleTitle = "Собственник";
        break;
      case 2:
        roleTitle = "Житель / член семьи";
        break;
      case 3:
        roleTitle = "Представитель собственника";
        break;
      case 4:
        roleTitle = "Арендатор";
        break;
    }

    userInfoCells.value.push({
      title: "Тип",
      content: roleTitle,
    });
  }

  if (userData?.lastName && userData?.firstName)
    userInfoCells.value.push({
      title: "ФИО",
      content: `${userData?.lastName} ${userData?.firstName}`,
    });

  if (userData?.age) {
    userInfoCells.value.push({ title: "Возраст", content: userData?.age });
  }

  if (userData?.phoneNumber)
    userInfoCells.value.push({
      title: "Телефон",
      content: phoneFormat(userData?.phoneNumber),
    });

  if (userData?.email) {
    userInfoCells.value.push({
      title: "Электронная почта",
      content: userData.email,
    });
  }

  if (userData?.sex) {
    userInfoCells.value.push({
      title: "Пол",
      content: userData.sex,
    });
  }

  if (userData?.place?.fullAddress) {
    userInfoCells.value.push({
      title: "Полный адрес",
      content: userData?.place?.fullAddress,
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "img-block" }, [
      _createElementVNode("img", { src: "img.png" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "block-title" }, "Переход в чат", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", null, " Перейти из мини-приложения в нативный чат по данному мини-приложению, если в нем есть чат ", -1)),
      _createVNode(AppButton, {
        block: "",
        onClick: goToChat
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Перейти в чат")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "block-title" }, "Переход к выбору тарифа подписки", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("div", null, "Перейти из мини-приложения на экран выбора тарифа подписки", -1)),
      _createVNode(AppButton, {
        block: "",
        onClick: goToPaywalls
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("Перейти к тарифам подписок")
        ])),
        _: 1
      })
    ]),
    (_unref(Domyland).superApp.payload)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "divider payload-top" }, null, -1)),
          _createElementVNode("h3", _hoisted_4, " Payload: " + _toDisplayString(_unref(Domyland).superApp.payload), 1),
          _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "divider" }, null, -1))
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "block-title" }, "Скачивание и загрузка", -1)),
      _cache[15] || (_cache[15] = _createElementVNode("div", null, "Для теста скачается файл оферты", -1)),
      _createVNode(AppButton, {
        block: "",
        onClick: downloadFile
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("Скачать файл")
        ])),
        _: 1
      }),
      _createVNode(AppButton, {
        block: "",
        type: "secondary",
        onClick: _cache[0] || (_cache[0] = () => (fileInputElement.value as HTMLInputElement).click())
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [
          _createTextVNode(" Загрузить файл ")
        ])),
        _: 1
      }),
      _createElementVNode("input", {
        ref_key: "fileInputElement",
        ref: fileInputElement,
        type: "file",
        hidden: "",
        onChange: postFile
      }, null, 544),
      (!fileUploadResponse.value && !isFileUploadError.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _cache[11] || (_cache[11] = [
            _createElementVNode("svg", {
              width: "16",
              height: "17",
              viewBox: "0 0 16 17",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M2.5 8.5C2.5 5.46233 4.96233 3 8 3C11.0377 3 13.5 5.46233 13.5 8.5C13.5 11.5377 11.0377 14 8 14C4.96233 14 2.5 11.5377 2.5 8.5ZM8 1.5C4.1339 1.5 1 4.6339 1 8.5C1 12.3661 4.1339 15.5 8 15.5C11.8661 15.5 15 12.3661 15 8.5C15 4.6339 11.8661 1.5 8 1.5ZM7.03125 4.78125C7.03125 4.36704 7.36704 4.03125 7.78125 4.03125C8.19546 4.03125 8.53125 4.36704 8.53125 4.78125V8.30454C8.53125 8.37084 8.55759 8.43443 8.60447 8.48131L10.4991 10.3759C10.792 10.6688 10.792 11.1437 10.4991 11.4366C10.2062 11.7295 9.73131 11.7295 9.43842 11.4366L7.54381 9.54197C7.21562 9.21378 7.03125 8.76867 7.03125 8.30454V4.78125Z",
                fill: "#18181A",
                "fill-opacity": "0.5"
              })
            ], -1),
            _createTextVNode(" Файл не загружен ")
          ])))
        : (isFileUploadError.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[12] || (_cache[12] = [
              _createStaticVNode("<svg width=\"16\" height=\"17\" viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_55533_1168)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 8.5C0 4.0816 3.5816 0.5 8 0.5C12.4184 0.5 16 4.0816 16 8.5C16 12.9184 12.4184 16.5 8 16.5C3.5816 16.5 0 12.9184 0 8.5ZM11.7123 5.8522C12.0052 5.55931 12.0052 5.08444 11.7123 4.79154C11.4194 4.49865 10.9445 4.49865 10.6517 4.79154L8 7.44319L5.34835 4.79154C5.05546 4.49865 4.58058 4.49865 4.28769 4.79154C3.9948 5.08444 3.9948 5.55931 4.28769 5.8522L6.93934 8.50385L4.28769 11.1555C3.9948 11.4484 3.9948 11.9233 4.28769 12.2162C4.58058 12.5091 5.05546 12.5091 5.34835 12.2162L8 9.56451L10.6517 12.2162C10.9445 12.5091 11.4194 12.5091 11.7123 12.2162C12.0052 11.9233 12.0052 11.4484 11.7123 11.1555L9.06066 8.50385L11.7123 5.8522Z\" fill=\"#FF3B30\"></path></g><defs><clipPath id=\"clip0_55533_1168\"><rect width=\"16\" height=\"16\" fill=\"white\" transform=\"translate(0 0.5)\"></rect></clipPath></defs></svg> Ошибка загрузки ", 2)
            ])))
          : (fileUploadResponse.value && !isFileUploadError.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _cache[13] || (_cache[13] = [
                _createStaticVNode("<svg width=\"16\" height=\"17\" viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_55533_1208)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 8.5C0 4.0816 3.5816 0.5 8 0.5C12.4184 0.5 16 4.0816 16 8.5C16 12.9184 12.4184 16.5 8 16.5C3.5816 16.5 0 12.9184 0 8.5ZM5.33032 7.76967C5.03742 7.47678 4.56255 7.47678 4.26966 7.76967C3.97676 8.06256 3.97676 8.53744 4.26966 8.83033L6.86966 11.4303C7.16255 11.7232 7.63742 11.7232 7.93032 11.4303L12.3303 7.03033C12.6232 6.73744 12.6232 6.26256 12.3303 5.96967C12.0374 5.67678 11.5626 5.67678 11.2697 5.96967L7.39999 9.83934L5.33032 7.76967Z\" fill=\"#34C759\"></path></g><defs><clipPath id=\"clip0_55533_1208\"><rect width=\"16\" height=\"16\" fill=\"white\" transform=\"translate(0 0.5)\"></rect></clipPath></defs></svg> Файл загружен ", 2)
              ])))
            : _createCommentVNode("", true)
    ]),
    (userInfoCells.value.length)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_9))
      : _createCommentVNode("", true),
    (userInfoCells.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "block-title user-info" }, "Информация о пользователе", -1)),
          (isUserDataLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Загрузка... "))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(userInfoCells.value, (cell) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: cell.title,
                  class: "user-info-content-cell"
                }, [
                  _createElementVNode("div", null, _toDisplayString(cell.title), 1),
                  _createElementVNode("div", null, _toDisplayString(cell.content), 1)
                ]))
              }), 128))
        ]))
      : _createCommentVNode("", true),
    _cache[30] || (_cache[30] = _createElementVNode("hr", { class: "divider" }, null, -1)),
    _createElementVNode("div", _hoisted_12, [
      _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "block-title push" }, "Push-уведомления", -1)),
      _cache[19] || (_cache[19] = _createElementVNode("div", null, "Push придёт примерно через 5 секунд", -1)),
      _createVNode(AppButton, {
        type: "secondary",
        block: "",
        onClick: makePush
      }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [
          _createTextVNode(" Получить push ")
        ])),
        _: 1
      })
    ]),
    _cache[31] || (_cache[31] = _createElementVNode("hr", { class: "divider" }, null, -1)),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("h3", _hoisted_14, [
        _cache[22] || (_cache[22] = _createTextVNode(" Оплата ")),
        (_unref(Domyland).miniApp.paymentStatus === 1)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _cache[20] || (_cache[20] = [
              _createElementVNode("g", { "clip-path": "url(#clip0_55533_1208)" }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M0 8.5C0 4.0816 3.5816 0.5 8 0.5C12.4184 0.5 16 4.0816 16 8.5C16 12.9184 12.4184 16.5 8 16.5C3.5816 16.5 0 12.9184 0 8.5ZM5.33032 7.76967C5.03742 7.47678 4.56255 7.47678 4.26966 7.76967C3.97676 8.06256 3.97676 8.53744 4.26966 8.83033L6.86966 11.4303C7.16255 11.7232 7.63742 11.7232 7.93032 11.4303L12.3303 7.03033C12.6232 6.73744 12.6232 6.26256 12.3303 5.96967C12.0374 5.67678 11.5626 5.67678 11.2697 5.96967L7.39999 9.83934L5.33032 7.76967Z",
                  fill: "#34C759"
                })
              ], -1),
              _createElementVNode("defs", null, [
                _createElementVNode("clipPath", { id: "clip0_55533_1208" }, [
                  _createElementVNode("rect", {
                    width: "16",
                    height: "16",
                    fill: "white",
                    transform: "translate(0 0.5)"
                  })
                ])
              ], -1)
            ])))
          : (_unref(Domyland).miniApp.paymentStatus === 0)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _cache[21] || (_cache[21] = [
                _createElementVNode("g", { "clip-path": "url(#clip0_55533_1168)" }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M0 8.5C0 4.0816 3.5816 0.5 8 0.5C12.4184 0.5 16 4.0816 16 8.5C16 12.9184 12.4184 16.5 8 16.5C3.5816 16.5 0 12.9184 0 8.5ZM11.7123 5.8522C12.0052 5.55931 12.0052 5.08444 11.7123 4.79154C11.4194 4.49865 10.9445 4.49865 10.6517 4.79154L8 7.44319L5.34835 4.79154C5.05546 4.49865 4.58058 4.49865 4.28769 4.79154C3.9948 5.08444 3.9948 5.55931 4.28769 5.8522L6.93934 8.50385L4.28769 11.1555C3.9948 11.4484 3.9948 11.9233 4.28769 12.2162C4.58058 12.5091 5.05546 12.5091 5.34835 12.2162L8 9.56451L10.6517 12.2162C10.9445 12.5091 11.4194 12.5091 11.7123 12.2162C12.0052 11.9233 12.0052 11.4484 11.7123 11.1555L9.06066 8.50385L11.7123 5.8522Z",
                    fill: "#FF3B30"
                  })
                ], -1),
                _createElementVNode("defs", null, [
                  _createElementVNode("clipPath", { id: "clip0_55533_1168" }, [
                    _createElementVNode("rect", {
                      width: "16",
                      height: "16",
                      fill: "white",
                      transform: "translate(0 0.5)"
                    })
                  ])
                ], -1)
              ])))
            : _createCommentVNode("", true)
      ]),
      _cache[24] || (_cache[24] = _createElementVNode("div", null, "Произойдет переход на страницу оплаты", -1)),
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(catalogItems, (item) => {
          return _createElementVNode("div", {
            key: item.title,
            class: "catalog-item"
          }, [
            _createElementVNode("img", {
              src: item.img,
              width: "80px"
            }, null, 8, _hoisted_18),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(item.price) + " ₽", 1),
                _createVNode(AppButton, {
                  small: "",
                  onClick: ($event: any) => (buyItem(item))
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode("Купить")
                  ])),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ])
          ])
        }), 64))
      ]),
      _cache[25] || (_cache[25] = _createElementVNode("hr", { class: "divider" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_23, [
      _cache[27] || (_cache[27] = _createElementVNode("h3", { class: "block-title push" }, "Переход в тг", -1)),
      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text" }, "Произойдет переход в тг", -1)),
      _createElementVNode("div", null, [
        _createElementVNode("a", _hoisted_24, [
          _createVNode(AppButton, { block: "" }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [
              _createTextVNode(" Открыть ТГ ")
            ])),
            _: 1
          })
        ])
      ])
    ]),
    _cache[32] || (_cache[32] = _createElementVNode("hr", { class: "divider" }, null, -1))
  ]))
}
}

})